import EditGoldAndSilver from './EditGoldAndSilver'

export default EditGoldAndSilver
